import React, { useState, useEffect } from 'react';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';

function CountDownTimer(props) {
  const [times, setTimes] = useState({ remDays: 0, remHours: 0, remMinutes: 0, remSeconds: 0 });
  const { launchTime } = props;

  let countDownTimer;
  const getTimeCountDown = () => {
    countDownTimer = setInterval(() => setTimeInCountDown(launchTime), 1000);
  };

  const setTimeInCountDown = (date) => {
    const countryTimeZoneName = moment.tz.guess() !== undefined ? moment.tz.guess() : 'Asia/Kolkata';
    let now = moment.tz(countryTimeZoneName);
    let countDownDate = moment.tz(date, countryTimeZoneName);
    let timeleft = countDownDate.diff(now);

    if (timeleft >= 0) {
      const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
      setTimes({ ...times, remDays: days, remHours: hours, remMinutes: minutes, remSeconds: seconds });
      if (days === 0 && hours === 0 && minutes < 10) {
      }
    } else {
      clearInterval(countDownTimer);
    }
  };

  useEffect(() => {
    getTimeCountDown();
  }, []);

  return (
    <section id='countDownTimer'>
      <div>
        <span>Days</span>
        <span>{times.remDays}</span>
      </div>
      <div>
        <span>Hours</span>
        <span>{times.remHours}</span>
      </div>
      <div>
        <span>Min</span>
        <span>{times.remMinutes}</span>
      </div>
      <div>
        <span>Sec</span>
        <span>{times.remSeconds}</span>
      </div>
    </section>
  );
}

export default CountDownTimer;
